import ViolationTile from './ViolationTile';
import {FirebaseContext} from "./Firebase";
import {useContext, useEffect, useState} from "react";
import {selectedState} from "../App";
import {useRecoilState} from "recoil";

function LeftPanel(props) {

    let [selectedData,setSelectedData] = useRecoilState(selectedState)

    let firebase = useContext(FirebaseContext)

    const [violations, setViolations] = useState([])

    useEffect(() => {
        const unsubscribe = firebase
            .db.collection('violations')
            .onSnapshot(snapshot => {
                if (snapshot.size) {
                    let data = []
                    snapshot.forEach(doc =>
                        data.push({ ...doc.data() })
                    )

                    setViolations(data)
                    console.log(data)

                } else {

                }
            })
        return () => {
            unsubscribe()
        }
    }, [props.firebase])

  return (
    <div className="flex flex-col pt-4 pb-4 pl-8 pr-8 h-screen">
      <div className="bg-dark rounded-lg p-4">
        <div className="font-gilroy font-bold text-white text-28">COVISHIELD</div>
        <div className="font-gilroy font-bold text-white text-18 ml-1">{violations.length} VIOLATIONS</div>
      </div>
      <div className="h-8"></div>
      <div className="border-b pt-2 shadow-xl"></div>
      <div className="overflow-y-scroll mt-2">

          {
            violations.sort(function(a, b) {
              var nameA = a.time.toUpperCase(); // ignore upper and lowercase
              var nameB = b.time.toUpperCase(); // ignore upper and lowercase
              if (nameA < nameB) {
                return 1;
              }
              if (nameA > nameB) {
                return -1;
              }

              // names must be equal
              return 0;
            }).map(violation => <div onClick={()=>setSelectedData({selected:true,name:violation.violater,violation:violation.violation,time:violation.time,lat:violation.lat,lng:violation.lng,imagepath:violation.imagepath})} ><ViolationTile {...violation} /></div>)}
        </div>
      </div>
    );
  }

  export default LeftPanel;
